import {
    AppointmentsModel,
} from 'one-card-appointments-table';

import {
    SET,
    REINIT,
    ADD,
    SETPATIENT,
    PUSHCANCELAPPT,
    RESETCANCELNOTIFICATION,
    PUSHCONFIRMAPPT,
    REINITONPATIENTCHANGE,
    PUSHUPDATEAPPT,
} from './types';

import {
    Actions,
} from './actions';

/**
 * 
 * @param context contains settings.json etc
 * @param initial initial state if set
 */
export const appointments = (
    context: any,
    initial?: AppointmentsModel,
) => {
    let initalselecttype = "future";

    let initialstate = initial || {
        appointmentSelectedType: initalselecttype
    };
    return (
        state: AppointmentsModel,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;

        let cancelmsg = '';
        let apptcode = '0';
        if (type === PUSHCANCELAPPT) {
            if (Array.isArray(payload) && payload.length > 0) {
                let val = payload[0];
                if (val && val.Success && val.Success === '1') {
                    cancelmsg = `Appointment Successfully Cancelled`;
                    apptcode = val.Success;
                } else if (val && val.Success && val.Success === '0') {
                    cancelmsg = val.Error;
                    apptcode = val.Success;
                }
            } else {
                cancelmsg = `Unable to cancel the appointment, please try to cancel the appointment in Epic Hyperspace`;
            }
        } else if (type === PUSHCONFIRMAPPT) {
            if (payload.erroritems && payload.erroritems.length) {
                cancelmsg = `Unable to confirm the appointment, please try to confirm the appointment in Epic Hyperspace`;
                apptcode = '0';
            } else {
                cancelmsg = `Appointment Successfully Confirmed`;
                apptcode = "1";
            }
        }
        else if (type === PUSHUPDATEAPPT) {
            if (payload?.erroritems && payload?.erroritems.length) {
                cancelmsg = `Failed to save the Appointment Notes`;
                apptcode = '0';
            } else {
                cancelmsg = `Appointment Notes Successfully Updated`;
                apptcode = '1';
            }
        }
        let updated = state || initialstate;
        switch (type) {
            case SET:
                updated = {
                    ...payload,
                    appointmentSelectedType: updated.appointmentSelectedType,
                }
                break;
            case SETPATIENT:
                updated = {
                    ...updated,
                    selectedPatientId: payload,
                }
                break;
            case ADD:
                updated = {
                    ...updated,
                    appointmentSelectedType: payload?.appointmentSelectedType,
                }
                break;
            case PUSHCANCELAPPT:
            case PUSHCONFIRMAPPT:
             case PUSHUPDATEAPPT:
                updated = {
                    ...updated,
                    cancelmsg: cancelmsg,
                    apptcode: apptcode
                };
                break;
            case RESETCANCELNOTIFICATION:
                updated = {
                    ...updated,
                    ...payload
                };
                break;
            case REINIT:
                updated = initialstate;
                break;
            case REINITONPATIENTCHANGE:
                updated = {
                    appointmentSelectedType: updated.appointmentSelectedType
                }
                break;    
        }
        return updated;
    }
};
